<template>
    <div style="height: 100%">
      <!--告警趋势-->
      <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;display: flex;align-items: center;justify-content: space-between;padding-right: 25px;" v-if="!label">
        <div>
          <span
              style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
          <span style="">{{ timeRangeText }}告警趋势</span>
        </div>
        <el-select v-model="timeRange" placeholder="请选择" size="small" style="width: 100px;" @change="handleTimeChange">
          <el-option label="周" value="week"></el-option>
          <el-option label="月" value="month"></el-option>
          <el-option label="季" value="quarter"></el-option>
          <el-option label="年" value="year"></el-option>
        </el-select>
      </div>
      <div style="margin-top: 15px;margin-right: 5px;font-weight: bold;margin-left: 25px;display: flex;align-items: center;justify-content: space-between;padding-right: 25px;" v-if="label">
        <label>{{ timeRangeText }}告警趋势</label>
        <el-select v-model="timeRange" placeholder="请选择" size="mini" style="width: 70px;" @change="handleTimeChange">
          <el-option label="周" value="week"></el-option>
          <el-option label="月" value="month"></el-option>
          <el-option label="季" value="quarter"></el-option>
          <el-option label="年" value="year"></el-option>
        </el-select>
      </div>
      <div v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.0)" style="height: 70%">
        <line-chart1 :data="alarmTrendData" ref="lineChart1" style="height: 100%" :route="route"
                     v-if="alarmTrendData.length > 0"></line-chart1>
        <no-data style="text-align: center;margin-top: 12%" v-else></no-data>
      </div>
    </div>
</template>

<script>
import LineChart1 from "@/components/echarts/LineChart1";
import {getAlarmRecordTendency} from "@/network/alarm-record";
import NoData from "@/components/NoData";

export default {
  name: "AlarmTrend",
  components: {LineChart1, NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    spaceId: {
      type: String,
      default: () => null
    },
    tagId: {
      type: String,
      default: null,
    }
  },
  watch: {
    spaceId() {
      this.getData();
    },
    tagId() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getAlarmTrend:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAlarmTrend')
  },
  data() {
    return {
      alarmTrendData: [],
      route:'/realTime-alarm',
      timeRange: 'week', // 默认选择周
      loading: false
    }
  },
  computed: {
    timeRangeText() {
      const textMap = {
        'week': '一周',
        'month': '一月',
        'quarter': '一季',
        'year': '一年'
      };
      return textMap[this.timeRange] || '一周';
    }
  },
  methods: {
    handleTimeChange() {
      this.getData();
    },
    getData() {
      this.loading = true;
      getAlarmRecordTendency(this.spaceId, this.tagId, this.timeRange).then(res => {
        this.alarmTrendData = [];
        if (res.code === 0) {
          if (res.data.length > 0) {
            // 如果是周数据，反转数组顺序
            let dailyAlarmList = res.data;
            if (this.timeRange === 'week') {
              dailyAlarmList = [...dailyAlarmList].reverse();
            }
            const alarmData = [];
            const date = [];
            const count = [];
            const arrowData = [];
            for (let dailyAlarmIndex = 0; dailyAlarmIndex < dailyAlarmList.length; dailyAlarmIndex++) {
              const dailyAlarm = dailyAlarmList[dailyAlarmIndex]
              const alarm = [];
              // 使用新的数据格式：label 和 count
              let labelText = dailyAlarm.label;
              // 如果是周数据（日期格式），只显示月-日
              if (this.timeRange === 'week' && labelText.includes('-')) {
                labelText = labelText.slice(5); // 从 "2025-11-17" 截取为 "11-17"
              }
              date.push(labelText);
              count.push(dailyAlarm.count);
              alarm.push(labelText, dailyAlarm.count);
              arrowData.push(alarm);
            }
            alarmData.push(date, count, arrowData);
            this.alarmTrendData = alarmData;
          }
        }
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>
